import React, { useState, useEffect } from 'react';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="site-branding">
          <h1 className="site-title">
            <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>
              Askeko
            </a>
          </h1>
        </div>

        <nav id="site-navigation" className="main-navigation">
          <button 
            className="menu-toggle" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-controls="primary-menu" 
            aria-expanded={isMobileMenuOpen}
          >
            <span className="menu-icon">☰</span>
            <span className="screen-reader-text">Menu</span>
          </button>
          
          <ul className={`primary-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <li>
              <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>
                Accueil
              </a>
            </li>
            <li>
              <a href="#benefits" onClick={(e) => { e.preventDefault(); scrollToSection('benefits'); }}>
                Bénéfices
              </a>
            </li>
            <li>
              <a href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollToSection('how-it-works'); }}>
                Comment ça marche
              </a>
            </li>
            <li>
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
